import { render, staticRenderFns } from "./HSwiperItem.vue?vue&type=template&id=e4f2b0ec&scoped=true&"
import script from "./HSwiperItem.vue?vue&type=script&lang=js&"
export * from "./HSwiperItem.vue?vue&type=script&lang=js&"
import style0 from "./HSwiperItem.vue?vue&type=style&index=0&id=e4f2b0ec&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4f2b0ec",
  null
  
)

export default component.exports